<template>
  <div>
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
        <el-breadcrumb-item :to="{ path: '/costCategory' }" style="font-size:24px">费用类别</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size:24px">费用二类</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="addDepartment" type="primary" size="medium"
          style="margin-bottom:10px;margin-top:20px;">新建费用二类</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-table :data="departmentData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="80" min-width="80"></el-table-column>
          <el-table-column prop="SECOND_TYPE_NAME" label="费用二类"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="项目上报">
            <template slot-scope="scope">
              {{ showStatusO(scope.row.REPORTABLE_SUBJECT) }}
            </template>
          </el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="公司上报">
            <template slot-scope="scope">
              {{ showStatus(scope.row.REPORTABLE_SUBJECT) }}
            </template>
          </el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="上报频次">
            <template slot-scope="scope">
              {{ showTable[scope.row.BE_MULTIPLE_DATA] }}
            </template>
          </el-table-column>
          <el-table-column prop="RELATED_BUDGE_NAME" label="关联预算"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="填选供应商">
            <template slot-scope="scope">
              {{ scope.row.CAN_SELECT_SUPPLIER == 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openEdit(scope.row)" icon="el-icon-edit">修改 </el-button>
              <el-button type="text" size="small" icon="el-icon-check" style="color:#67C23A"
                @click="startDepartment(scope.row)" v-if="scope.row.STATUS === 0">启用
              </el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color:  #F56C6C"
                @click="stopDepartment(scope.row)" v-else>禁用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalNum" style="float: right">
      </el-pagination>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="修改费用类别信息" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" :label-width="formLabelWidth">
            <el-form-item label="名称：">
              <el-input v-model="editForm.SECOND_TYPE_NAME"></el-input>
            </el-form-item>
            <el-form-item label="项目上报：">
              <el-checkbox v-model="editForm.projectChecked"></el-checkbox>
            </el-form-item>
            <el-form-item label="公司上报：">
              <el-checkbox v-model="editForm.companyChecked"></el-checkbox>
            </el-form-item>
            <el-form-item label="填选供应商：">
              <el-checkbox v-model="editForm.CAN_SELECT_SUPPLIER" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close('editForm')">取 消</el-button>
            <el-button @click="submitEdit()">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增费用类别信息" center :visible.sync="addFormVisible" width="400px">
          <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
            <el-form-item label="名称：" prop="NAME">
              <el-input v-model="addForm.NAME"></el-input>
            </el-form-item>
            <el-form-item label="项目上报：" prop="NAME">
              <el-checkbox v-model="addForm.projectChecked"></el-checkbox>
            </el-form-item>
            <el-form-item label="公司上报：" prop="NAME">
              <el-checkbox v-model="addForm.companyChecked"></el-checkbox>
            </el-form-item>
            <el-form-item label="填选供应商：">
              <el-checkbox v-model="addForm.CAN_SELECT_SUPPLIER" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>
            <el-form-item label="上报频次   ：" prop="NAME">
              <el-radio-group v-model="addForm.resource">
                <el-radio :label="1">多条</el-radio>
                <el-radio :label="0">单条</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关联预算：" prop="DEPARTMENT">
              <label slot="label">关联预算：</label>
              <el-select v-model="addForm.DEPARTMENT" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in departments" :key="item.E_NAME" :label="item.C_NAME"
                  :value="item.E_NAME"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close('addForm')">取 消</el-button>
            <el-button @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data () {
    return {
      // loading:false,
      departmentData: [],
      showTable: ['单条', '多条'],
      editFormVisible: false,
      addFormVisible: false,
      editForm: {
        companyChecked: false,
        projectChecked: false,
        CAN_SELECT_SUPPLIER: 0,
      },
      addForm: {
        resource: 1,
        companyChecked: false,
        projectChecked: false,
        CAN_SELECT_SUPPLIER: 0,
      },
      form: {},
      REPORTABLE_SUBJECT: 0,
      formLabelWidth: '100px',
      departments: [],
      currentPage: 1,
      totalNum: 0,
      pageSize: 20,
    };
  },
  mounted () {
    this.queryList();
    this.queryDepartment();
  },
  methods: {
    queryList (index) {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 10,
        TC_ID: Number(sessionStorage.getItem('companyId')),
        FIRST_TYPE_ID: this.$route.params.firstId,
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      http.post(params).then((result) => {
        this.departmentData = result[0].OP_ROLE;
        this.totalNum = result[0].TOTAL_COUNT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    showStatus (status) {
      if (status == 2 || status == 3) {
        return '是';
      }
      return '否';
    },
    showStatusO (status) {
      if (status == 1 || status == 3) {
        return '是';
      }
      return '否';
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryList();
    },
    openEdit (row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.editForm.projectChecked = (row.REPORTABLE_SUBJECT == 1 || row.REPORTABLE_SUBJECT == 3);
      this.editForm.companyChecked = (row.REPORTABLE_SUBJECT == 2 || row.REPORTABLE_SUBJECT == 3);
      this.editForm.CAN_SELECT_SUPPLIER = row.CAN_SELECT_SUPPLIER == 1 ? 1 : 0;
    },
    close () {
      this.editForm.FIRST_TYPE_NAME = this.emp;
      this.addForm.FIRST_TYPE_NAME = '';
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.editForm = {};
      this.addForm = {};
    },
    queryDepartment () {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 11,
        TC_ID: Number(sessionStorage.getItem('companyId')),
      };
      http.post(params).then((result) => {
        this.departments = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    selectDepartment (e) {
      this.editForm.DEPARTMENT_ID = e;
    },
    submitEdit () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.editForm.companyChecked == true) {
            this.editForm.REPORTABLE_SUBJECT = 2;
          }
          if (this.editForm.projectChecked == true) {
            this.editForm.REPORTABLE_SUBJECT = 1;
          }
          if (this.editForm.projectChecked == true && this.editForm.companyChecked == true) {
            this.editForm.REPORTABLE_SUBJECT = 3;
          }
          if (this.editForm.projectChecked == false && this.editForm.companyChecked == false) {
            console.log(1111);
            this.$message.show({ text: '请选择项目或公司上报', type: 'warning' });
            return false;
          }

          const params = {
            SERVICE_ID: '10013',
            OTYPE: 7,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            NAME: this.editForm.SECOND_TYPE_NAME,
            FIRST_TYPE_ID: this.$route.params.firstId,
            SECOND_TYPE_ID: this.editForm.SECOND_TYPE_ID,
            BE_MULTIPLE_DATA: this.editForm.BE_MULTIPLE_DATA,
            REPORTABLE_SUBJECT: this.editForm.REPORTABLE_SUBJECT,
            CAN_SELECT_SUPPLIER: this.editForm.CAN_SELECT_SUPPLIER == 1 ? 1 : 0,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    startDepartment (row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 9,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            SECOND_TYPE_ID: row.SECOND_TYPE_ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    stopDepartment (row) {
      this.$confirm('您确定禁用该费用类别吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10013',
          OTYPE: 8,
          TC_ID: Number(sessionStorage.getItem('companyId')),
          SECOND_TYPE_ID: row.SECOND_TYPE_ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    addDepartment () {
      this.addForm = {
        resource: 1,
        companyChecked: false,
        projectChecked: false,
        CAN_SELECT_SUPPLIER: 0,
      };
      this.addFormVisible = true;
    },
    submitAdd () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.addForm.companyChecked == true) {
            this.REPORTABLE_SUBJECT = 2;
          }
          if (this.addForm.projectChecked == true) {
            this.REPORTABLE_SUBJECT = 1;
          }
          if (this.addForm.projectChecked == true && this.addForm.companyChecked == true) {
            this.REPORTABLE_SUBJECT = 3;
          }
          if (this.addForm.projectChecked == false && this.addForm.companyChecked == false) {
            this.$message.show({ text: '请选择项目或公司上报', type: 'warning' });
            return false;
          }
          console.log(this.REPORTABLE_SUBJECT);
          const params = {
            SERVICE_ID: '10013',
            OTYPE: 6,
            TC_ID: Number(sessionStorage.getItem('companyId')),
            NAME: this.addForm.NAME,
            BE_MULTIPLE_DATA: this.addForm.resource,
            FIRST_TYPE_ID: this.$route.params.firstId,
            REPORTABLE_SUBJECT: this.REPORTABLE_SUBJECT,
            CAN_SELECT_SUPPLIER: this.addForm.CAN_SELECT_SUPPLIER == 1 ? 1 : 0,
            RELATED_BUDGE_NAME: this.addForm.DEPARTMENT || '',
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          document.body.style.cursor = 'default';
        }
      }
    },
    openDetail (row) {
      this.$router.push({ name: 'costCategoryDetail', params: { firstId: row.FIRST_TYPE_ID } });
    },
  },
};
</script>
<style scoped>
/* .container{

} */
</style>



// WEBPACK FOOTER //
// src/components/costCategoryDetail.vue